import * as THREE from 'three';

export class Projectile {
  readonly object3D: THREE.Group;
  readonly velocity = new THREE.Vector3();
  readonly prevPos = new THREE.Vector3();
  readonly radius = 0.6;
  damage = 1;
  age = 0;
  maxAge = 2.6;
  active = false;

  private readonly core: THREE.Mesh;
  private readonly innerHalo: THREE.Mesh;
  private readonly outerHalo: THREE.Mesh;
  private readonly tmpLook = new THREE.Vector3();

  constructor() {
    this.object3D = new THREE.Group();
    this.object3D.name = 'projectile';
    this.object3D.visible = false;

    this.core = makeLayer(0.065, 0.55, 0xffffff, 1.0);
    this.innerHalo = makeLayer(0.16, 0.78, 0xc8e4ff, 0.65);
    this.outerHalo = makeLayer(0.3, 1.05, 0x5aa5ff, 0.28);

    this.object3D.add(this.outerHalo, this.innerHalo, this.core);
  }

  spawn(
    worldPos: THREE.Vector3,
    velocity: THREE.Vector3,
    damage: number
  ): void {
    this.object3D.position.copy(worldPos);
    this.prevPos.copy(worldPos);
    this.tmpLook.copy(worldPos).add(velocity);
    this.object3D.lookAt(this.tmpLook);
    this.velocity.copy(velocity);
    this.damage = damage;
    this.age = 0;
    this.active = true;
    this.object3D.visible = true;
  }

  update(dt: number): void {
    if (!this.active) return;
    this.age += dt;
    if (this.age >= this.maxAge) {
      this.deactivate();
      return;
    }
    this.prevPos.copy(this.object3D.position);
    this.object3D.position.addScaledVector(this.velocity, dt);
  }

  deactivate(): void {
    this.active = false;
    this.object3D.visible = false;
  }

  dispose(): void {
    this.core.geometry.dispose();
    (this.core.material as THREE.Material).dispose();
    this.innerHalo.geometry.dispose();
    (this.innerHalo.material as THREE.Material).dispose();
    this.outerHalo.geometry.dispose();
    (this.outerHalo.material as THREE.Material).dispose();
  }
}

function makeLayer(
  radius: number,
  length: number,
  color: number,
  opacity: number
): THREE.Mesh {
  const geo = new THREE.CapsuleGeometry(radius, length, 6, 12);
  geo.rotateX(-Math.PI / 2);
  const mat = new THREE.MeshBasicMaterial({
    color,
    transparent: true,
    opacity,
    blending: THREE.AdditiveBlending,
    depthWrite: false,
    toneMapped: false
  });
  return new THREE.Mesh(geo, mat);
}
